import AuthApi from '@/api/auth'
import Vue from 'vue'
import { TOKEN, ROLES, USER_INFO } from '@/store/mutation-types'
import { notification } from 'ant-design-vue'
import UserApi from '@/api/user'
import { menuCodeToPermissions } from '@/utils/util'
import Cookies from 'js-cookie'
const user = {
	namespaced: true,
	state: {
		userId: '',
		userName: '',
		name: '',
		welcome: '',
		avatar: '',
		roles: [],
		userInfo: {},
		snapshotToken: '',
		waitCheckCount: 0,
	},

	mutations: {
		SET_NAME: (state: any, payload: any) => {
			state.name = payload.name
			state.welcome = payload.welcome
		},
		SET_AVATAR: (state: any, avatar: string) => {
			state.avatar = avatar
		},
		SET_ROLES: (state: any, roles: string) => {
			state.roles = roles
		},
		SET_USER_INFO: (state: any, userInfo: any) => {
			state.userInfo = userInfo
		},
		SET_SS_TOKEN: (state: any, token: string) => {
			state.snapshotToken = token
		},
		SET_COUNT_INFO: (state: any, waitCheckCount: Number) => {
			state.waitCheckCount = waitCheckCount
		},
	},

	actions: {
		// 登录
		async Login(store: any, userInfo: any) {
			Cookies.remove('token', { domain: 'cias.cn' })
			let res = await AuthApi.loginByUsername(userInfo)
			const { token, level } = res.data
			Vue.ls.set('level', level)
			Vue.ls.set(TOKEN, token)
			return res
		},
		// LDAP登录
		async ldapLogin(store: any, userInfo: any) {
			Cookies.remove('token', { domain: 'cias.cn' })
			let res = await AuthApi.ldapLogin(userInfo)
			const { token, level } = res.data
			Vue.ls.set('level', level)
			Vue.ls.set(TOKEN, token)
			return res
		},
		// 钉钉登录
		async ddLogin(store: any, userInfo: any) {
			Cookies.remove('token', { domain: 'cias.cn' })
			let res = await AuthApi.ddLogin(userInfo)
			const { token, level } = res.data
			Vue.ls.set('level', level)
			Vue.ls.set(TOKEN, token)
			return res
		},
		async getUserInfo(store: any) {
			const res = await UserApi.getUserInfo()
			const level = Vue.ls.get('level')
			const info = {
				userId: res.data.userId,
				userName: res.data.userName,
				companyNo: res.data.companyNo,
				name: res.data.name,
				mobile: res.data.mobile,
				companyId: res.data.companyId,
				permissionCode: res.data.permissionCode,
				level,
			}
			store.commit('SET_USER_INFO', info)
			// 平安定制相关字典值
			store.dispatch('setting/getDicPAIC', null, { root: true })
			Vue.ls.set(USER_INFO, info)
		},
		async GetInfo(store: any) {
			const { data: authInfo } = await AuthApi.getPermession()
			let role = {
				menuPermissions: [],
				actionPermissions: {},
			}
			if (!authInfo || !authInfo.length) {
				role = {
					menuPermissions: [],
					actionPermissions: {},
				}
			} else {
				role = menuCodeToPermissions(authInfo)
			}
			Vue.ls.set(ROLES, role)
			store.commit('SET_ROLES', role)
			return role
		},
		// 获取初审消息
		async getCountInfo(store: any) {
			const res = await UserApi.countInfo()
			store.commit('SET_COUNT_INFO', res.data.waitCheckCount)
		},

		// 登出
		Logout(state: any) {
			return new Promise(resolve => {
				AuthApi.logout()
					.then(() => {
						resolve()
					})
					.catch(() => {
						resolve()
					})
					.finally(() => {
						Vue.ls.remove(TOKEN)
						Vue.ls.remove(ROLES)
						Vue.ls.remove(USER_INFO)
					})
			})
		},
	},
}

export default user
